import * as React from "react"
import {DrawerSeeker} from "@ui-seeker/core";

import {disabledMatcherSKUForm, isOpenDrawerMatcherSKU, matcherSKUDrawerData, matcherSKUDrawerError} from "../@signals";
import {useMatchersSkusForm} from "../@hooks";
import MatchersSKUsDrawerContent from "./Content";


export default function MatchersSKUsDrawer() {
	const { handleSubmit, isLoading } = useMatchersSkusForm()

    return <DrawerSeeker
		disableCloseOnSuccess
		width="55%"
		isOpen={isOpenDrawerMatcherSKU.value}
		controller={() => {
			matcherSKUDrawerData.value = {}
			matcherSKUDrawerError.value = {}
		}}
		title="Create a new SKU"
		successProps={{
			disabled: disabledMatcherSKUForm.value,
			loading: isLoading,
			onClick: handleSubmit
		}}
	>
		<MatchersSKUsDrawerContent />
	</DrawerSeeker>
}